import * as React from 'react';
import Routes from 'routes';
import '_business/translations';
import { ScrollToTop } from '_technical/components';
import { App as AntApp, ConfigProvider } from 'antd';
import appTheme from '_business/theme/theme';
import { AuthContextProvider } from '_technical/contexts/AuthContext';
import {
  QueryCache,
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query';
import * as Userpilot from '_technical/tools/Userpilot';
import { useLocation } from 'react-router';

export const queryCache = new QueryCache();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      retryOnMount: false,
      refetchOnReconnect: false,
      retry: false,
      staleTime: 1000 * 60 * 60 * 24,
    },
    mutations: {
      retry: false,
    },
  },
  queryCache,
});

export default function App() {
  const location = useLocation();

  React.useEffect(() => {
    Userpilot.reload();
  }, [location]);

  return (
    <QueryClientProvider client={queryClient}>
      <AuthContextProvider>
        <ConfigProvider {...appTheme}>
          <AntApp>
            <ScrollToTop />
            <Routes />
          </AntApp>
        </ConfigProvider>
      </AuthContextProvider>
    </QueryClientProvider>
  );
}
